<template>
  <div class="wrapper-page">
    <div class="card login-card">
      <div class="card-body">
        <h3 class="text-center mt-3 mb-3">忘記密碼</h3>
        <div class="col-12">
          <div class="alert alert-primary fade show" role="alert">
            <i class="mdi mdi-alert-circle-outline mr-2"></i>
            請輸入你註冊時的 Email，我們會發送一封信件，點擊信件中的連結以重設密碼。找不到認證信時，請到「垃圾信件」分類查找，或在信箱搜尋「臺中市智能路燈管理系統」。
          </div>
        </div>
        <form class="form-horizontal">
          <div class="col-12">
            <div class="form-group">
              <label for="email" class="text-muted">請輸入您的的 Email</label>
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="fas fa-envelope"></i>
                </div>
                <input id="email" type="email" class="form-control" required v-model="email">
              </div>
            </div>
          </div>

          <div class="form-group text-center m-t-40">
            <div class="col-12">
              <a href="/login" class="btn btn-outline-info btn-block btn-lg waves-effect waves-light">取消</a>
            </div>
          </div>
          <div class="form-group text-center">
            <div class="col-12">
              <button class="btn btn-info btn-block btn-lg waves-effect waves-light" type="button"
                @click="sendBtn">送出</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { api } from "../../../apis/main.js";
import { IsNullOrEmpty } from '../../../components/helpers.js';
let $ = window.$;
export default {
  name: 'ForgetView',
  props: {
  },
  components: {
  },
  data() {
    return {
      email: '',
    }
  },
  mounted: async function () {
    localStorage.clear();
  },
  methods: {
    sendBtn(e) {
      let showError = function (str) {
        swal({
          title: "Opps!",
          type: "warning",
          html: true,
          text:
            "<label class='h6'>" +
            str +
            "</label>",
        });
      }

      if (IsNullOrEmpty(this.email)) {
        showError('請輸入信箱帳號');
        return;
      }
      e.preventDefault();

      api.post("reset_password_mail", this.email).then(res => {
        swal({
          title: "Email已送出!",
          html: true,
          button: '確認，返回登入頁',
          text:
            "<label class='h6'>" +
            '系統將會寄送密碼設定連結至您的信箱' +
            "</label>",
        }, (res) => {
          if (res) {
            window.location.href = '/login';
          }
        });
      }).catch(error => {
        showError(error.response.data.detail);
      });
    },

  }
}
</script>

<style scoped>

</style>
